import { useLayoutEffect, useState, type RefObject } from 'react';

/** Room kept between a popover and the edge of the screen. */
const EDGE = 16;

/**
 * Which edge of its trigger a dropdown popover lines up with. It opens under the trigger's right edge (pickers sit
 * on the right of a toolbar), unless that would push it off the left of the screen, as when a narrow toolbar wraps
 * the picker to the left; then it lines up with the left edge instead. Measured before paint, so it never jumps.
 */
export function usePopoverSide(open: boolean, rootRef: RefObject<HTMLElement | null>, popoverRef: RefObject<HTMLElement | null>) {
  const [side, setSide] = useState<'left' | 'right'>('right');

  useLayoutEffect(() => {
    const root = rootRef.current;
    const popover = popoverRef.current;
    if (!open || !root || !popover) return;
    setSide(root.getBoundingClientRect().right - popover.offsetWidth < EDGE ? 'left' : 'right');
  }, [open, rootRef, popoverRef]);

  return side;
}
